import * as React from 'react';

function EmailIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32.5}
      height={24.625}
      viewBox="0 0 32.5 24.624"
      {...props}
    >
      <g data-name="481659 (1)">
        <g data-name="Group 1111">
          <path
            data-name="Path 662"
            d="M29.375.5H3.125A2.628 2.628 0 00.5 3.125V21.5a2.628 2.628 0 002.625 2.625h26.25A2.628 2.628 0 0032 21.5V3.125A2.628 2.628 0 0029.375.5zM3.125 1.812h26.25a1.249 1.249 0 01.273.055c-2.273 2.08-9.808 8.974-12.445 11.35a1.316 1.316 0 01-1.905 0C12.66 10.841 5.124 3.947 2.852 1.868a1.256 1.256 0 01.273-.056zM1.812 21.5V3.125a1.268 1.268 0 01.073-.363c1.739 1.592 7 6.4 10.407 9.5-3.4 2.919-8.658 7.905-10.411 9.577a1.265 1.265 0 01-.069-.339zm27.563 1.313H3.125a1.256 1.256 0 01-.3-.06c1.812-1.727 7.1-6.742 10.443-9.6.435.395.833.755 1.146 1.037a2.622 2.622 0 003.663 0l1.147-1.038c3.339 2.856 8.631 7.87 10.443 9.6a1.255 1.255 0 01-.292.061zm1.313-1.313a1.267 1.267 0 01-.069.342c-1.754-1.673-7.013-6.658-10.411-9.577 3.41-3.1 8.667-7.91 10.407-9.5a1.268 1.268 0 01.073.363z"
            fill="#fff"
            stroke="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default EmailIcon;
